<template>
    <v-container fluid>
      <!-- Properties Section -->
      <v-row>
        <v-col cols="12">
          <v-card class="card-section">
            <v-card-title class="card-title">
              <v-icon left>mdi-home</v-icon> <!-- House Icon -->
              Properties
            </v-card-title>
            <v-card-text>
              <!-- Progress Bar for Vacant and Occupied Properties -->
              <v-progress-linear
                :value="occupiedPropertiesPercentage"
                color="green"
                :buffer-value="100"
                class="progress-bar"
                height="30"
                @click="goToPage('/Properties')" >
              
                <template v-slot:default>
                  <!-- Details slot displaying counts of vacant and occupied properties -->
                  <div class="progress-text">
                    {{ occupiedPropertiesCount }} / {{ totalProperties }} Occupied |
                    {{ vacantPropertiesCount }} Vacant
                  </div>
                </template>
              </v-progress-linear>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>
  import { getDocs, collection, getFirestore } from "firebase/firestore";
  const db = getFirestore();
  
  export default {
    data() {
      return {
        properties: [],
      };
    },
    computed: {
      // Compute total properties and vacant property count
      totalProperties() {
        return this.properties.length;
      },
      occupiedPropertiesCount() {
        return this.properties.filter(property => !property.isVacant).length;
      },
      vacantPropertiesCount() {
        return this.properties.filter(property => property.isVacant).length;
      },
      // Compute the percentage of occupied properties for the progress bar
      occupiedPropertiesPercentage() {
        if (this.totalProperties === 0) return 0;
        const percentage = (this.occupiedPropertiesCount / this.totalProperties) * 100;
        return isNaN(percentage) ? 0 : percentage;
      },
    },
    async created() {
      await this.fetchProperties();
    },
    methods: {
      async fetchProperties() {
        try {
          const querySnapshot = await getDocs(collection(db, 'properties'));
          const properties = querySnapshot.docs.map(doc => {
            const data = doc.data();
            return {
              property: data.reference,
              isVacant: data.isVacant,
            };
          });
          this.properties = properties;
          console.log("Fetched properties:", properties);  // Log to check fetched data
        } catch (error) {
          console.error("Error fetching properties:", error);
        }
      },
      goToPage(page) {
      this.$router.push(page);
    },
    },
  };
  </script>
  
  <style scoped>
  .card-section {
    background-color: #f5f5f5;
    padding: 16px;
    border-radius: 8px;
  }
  
  .card-title {
    font-size: 20px;
    font-weight: bold;
    color: #1e88e5;
  }
  
  .progress-bar {
    margin-bottom: 12px;
  }
  
  .progress-text {
    color: white; /* Ensures the text is visible inside the progress bar */
    text-align: center;
    font-weight: bold;
  }
  
  .data-item {
    margin-top: 8px;
    font-size: 16px;
  }
  </style>
  